import { IconTile } from "@screener/uikit/components/icon-tile";
import { Panel, PanelFooter, PanelHeader } from "@screener/uikit/components/panel";
import { type ReactNode, useId } from "react";

/** `id` панели раздела в документе: на него ссылается навигация по разделам. */
export function settingsSectionDomId(sectionId: string): string {
  return `settings-${sectionId}`;
}

/**
 * Раздел страницы «Настройки» по макету DEN-162: панель с шапкой (плитка-иконка,
 * заголовок, описание, бейдж справа), строками настроек и необязательным
 * подвалом. Название раздела связано с областью (`role="region"` через
 * `aria-labelledby`). `sectionId` — якорь для навигации по разделам.
 */
export function SettingsSection({
  sectionId,
  icon,
  label,
  description,
  action,
  footer,
  cardRef,
  children,
}: {
  sectionId?: string;
  icon: ReactNode;
  label: string;
  /** Пояснение под заголовком, например «Настройки хранятся на этом устройстве.» */
  description?: string;
  /** Справа в шапке: бейдж состояния. */
  action?: ReactNode;
  /** Подвал панели: слева статус, справа кнопки. */
  footer?: ReactNode;
  cardRef?: (element: HTMLElement | null) => void;
  children: ReactNode;
}) {
  const headingId = useId();
  return (
    <Panel
      id={sectionId === undefined ? undefined : settingsSectionDomId(sectionId)}
      aria-labelledby={headingId}
      ref={cardRef}
      className="scroll-mt-7"
    >
      <PanelHeader
        icon={<IconTile size="sm">{icon}</IconTile>}
        title={label}
        titleId={headingId}
        description={description}
        action={action}
      />
      {children}
      {footer ? <PanelFooter>{footer}</PanelFooter> : null}
    </Panel>
  );
}
